import { Decision } from "components/Decision";
import { Page } from "pages/Page";

const title = "No student access";
const description = "Students cannot access this page";

export const NotStudentsPage = () => (
    <Page canonical={window.location.href} description={description} title={title}>
        <div className="container-mini">
            <Decision text={title} description={description} />
        </div>
    </Page>
);
